module.exports = __webpack_public_path__ + "static/img/location.0cedbcf7.png";